import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
const IconWrapper = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "FeatureTableUserIcon__IconWrapper",
  componentId: "rqegt4-0"
})([""]);

const FeatureTableUserIcon = ({
  freeUserAccess,
  showTooltip = true
}) => {
  return /*#__PURE__*/_jsx("p", {
    className: "m-all-0",
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !showTooltip,
      placement: "top",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `featureTable.freeUser.${freeUserAccess}`
      }),
      children: /*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-1",
          name: "contacts"
        })
      })
    })
  });
};

export default FeatureTableUserIcon;